module.exports = __webpack_public_path__ + "static/media/fachada1.1171de2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Fachada/fachada1.jpg
// module id = 323
// module chunks = 0